import apiInstance from "../Api/ApiInstance";

export async function Login(values) {
  const { email, password } = values;
  return await apiInstance.post("api/nexus-main/auth", { email, password });
}

export async function ApiLoginAdmin(values) {
  const { email, password } = values;
  return await apiInstance.post("api/nexus-main/auth/admin", { email, password });
}
